import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getSubscriptionPortal } from 'redux/actions/subscriptions';
import {
  loadMusePlans,
  checkoutMusePlan
} from 'redux/actions/musePlans';
import { hasSubscription, redirectTo } from 'libs/common';
import { endPoints } from 'config/routes';
import Subscriptions from './Subscriptions';
import './SubscriptionsWrapper.scss';
import Loader from 'components/Loader';

class SubscriptionsWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.isSubscribed = false;
    this.showPlans = false;
  }

  render() {
    const { userSubscriptions, auth: { isFetchingSubscriptions } } = this.props;

    if (isFetchingSubscriptions) {
      return (<Loader />);
    } else {
      this.isSubscribed = hasSubscription(userSubscriptions);
    }

    // to prevent direct access to route when user doesn't have plans
    if (!this.isSubscribed && !this.showPlans) {
      redirectTo(endPoints.accountSetting);
      return null;
    }

    return (
      <div className="Subscriptions" id="subscriptionView">
        {
          this.isSubscribed &&
          <Subscriptions
            userSubscriptions={userSubscriptions}
            getSubscriptionPortal={this.props.getSubscriptionPortal}
          />
        }
      </div>
    );
  }
}

SubscriptionsWrapper.propTypes = {
  getSubscriptionPortal: PropTypes.func.isRequired,
  userSubscriptions: PropTypes.array.isRequired
};

function mapStateToProps({
  subscriptions, musePlans,
  auth, windowDimension
}) {
  return {
    plans: musePlans,
    subscriptions,
    windowDimension,
    userSubscriptions: (auth.info && auth.info.subscriptions) || []
  };
}

export default connect(mapStateToProps, {
  loadMusePlans,
  checkoutMusePlan,
  getSubscriptionPortal
})(SubscriptionsWrapper);



// WEBPACK FOOTER //
// ./src/views/Subscriptions/SubscriptionsWrapper.jsx